import {
  CircularProgress,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { convertDigitToEnglish } from "common/method/convertDigitToEnglish";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";
import { useFormik } from "formik";
import { pishroKycOtp } from "redux/login/pishroKycOtp";
import { actionTypes as actionTypesNotif } from "redux/notificationAlert";
import * as Yup from "yup";
import { useTheme } from "@mui/material/styles";
import { selectClubmemberStatus } from "redux/clubMember/select_clubmember_status/select_clubmember_status";

const LoginPanel = ({
  flagLogin,
  setflagLogin,
  setUserInfo,
  setotpFlag,
  query_national_member_id,
}) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const theme = useTheme();
  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };
  const initialValues = {
    nationalId: query_national_member_id || "",
    isIndividual: "TRUE",
  };
  const loginOtpScheama = Yup.object().shape({
    nationalId: Yup.string()
      .min(10, "کد ملی/شناسه ملی حداقل باید 10 رقم و به صورت عدد باشد")
      .max(11, "کد ملی/شناسه ملی  حداکثر باید 11 رقم و به صورت عدد باشد")
      .required("وارد کردن کد ملی/شناسه ملی الزامی می‌باشد"),
    isIndividual: Yup.string().required(
      "لطفا حقیقی یا حقوقی بودن خود را تعیین کنید",
    ),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: loginOtpScheama,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true);
      const ENGnationalid = convertDigitToEnglish(values.nationalId);

      try {
        // First request: selectClubmemberStatus
        const res = await selectClubmemberStatus(
          ENGnationalid,
          values.isIndividual,
        );
        console.log("res", res);

        if (res?.data.response.data.body.is_successfull !== "TRUE") {
          window.location.href = `https://registration.pishrobroker.ir/login/?member_national_id=${ENGnationalid}&utm=berelian`;
          return;
        }

        // Second request: pishroKycOtp (only runs after first request completes successfully)
        const otpResponse = await pishroKycOtp(
          ENGnationalid,
          values.isIndividual,
        );

        setUserInfo({
          nationalId: ENGnationalid,
          isIndividual: values.isIndividual,
        });

        if (!Object.keys(otpResponse.data.response.data).length) {
          if (otpResponse.data.response.error_code === 105814) {
            dispatch({
              type: actionTypesNotif.warning,
              textAlert: otpResponse.data.response.error_description,
            });
          } else {
            handleNotificationAlertTrySelect(otpResponse);
          }
          return;
        }

        if (otpResponse?.data?.response?.is_successful === true) {
          dispatch({
            type: actionTypesNotif.success,
            textAlert: "پیامکی حاوی کد تایید برای شما ارسال خواهد شد",
          });
          setTimeout(() => {
            setflagLogin(2);
          }, 2000);
          setUserInfo({
            flag: true,
            nationalId: ENGnationalid,
            isIndividual: values.isIndividual,
          });
        }
      } catch (error) {
        handleNotificationAlertCatch();
      } finally {
        setLoading(false);
        setSubmitting(false);
      }
    },
  });
  const isValidNationalId =
    formik.values.nationalId.length >= 10 &&
    formik.values.nationalId.length < 12;
  return (
    <>
      <div className="flex flex-col">
        <div className="mt-7">
          <RadioGroup
            aria-label="isIndividual"
            value={formik.values.isIndividual}
            onChange={(e) =>
              formik.setFieldValue("isIndividual", e.target.value)
            }
            style={{ display: "flex", justifyContent: "flex-start" }}
            row
          >
            <FormControlLabel
              value={"TRUE"}
              control={<Radio color="primary" size={"small"} />}
              label={<Typography sx={{ fontSize: 14 }}>{"حقیقی"}</Typography>}
            />
            <FormControlLabel
              value={"FALSE"}
              control={<Radio color="primary" size={"small"} />}
              label={<Typography sx={{ fontSize: 14 }}>{"حقوقی"}</Typography>}
              style={{ fontSize: 12 }}
            />
          </RadioGroup>
        </div>

        <form
          onSubmit={formik.handleSubmit}
          className="form fv-plugins-bootstrap fv-plugins-framework"
        >
          <div className="fv-plugins-icon-container pt-3">
            <input
              placeholder={`${
                formik.values.isIndividual === "TRUE" ? "کد ملی" : "شناسه ملی"
              }`}
              type="tel"
              inputMode="numeric"
              pattern="[0-9]*"
              className={`w-full border text-right h-12 py-4 px-5 focus:border-gray-400 outline-none rounded-md ${getInputClasses(
                "nationalId",
              )} authInput`}
              name="nationalId"
              {...formik.getFieldProps("nationalId")}
              onChange={(event) => {
                formik.setFieldValue(
                  "nationalId",
                  event.target.value.replace(/\s/g, ""),
                );
              }}
            />
            <div className={`errorPlace`}>
              {formik.touched.nationalId && formik.errors.nationalId ? (
                <div className="fv-plugins-message-container flex mt-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    fill="red"
                    class="bi bi-exclamation-triangle-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                  </svg>
                  <div className="fv-help-block d-inline-block mr-1 text-xs text-red-400">
                    {formik.errors.nationalId}
                  </div>
                </div>
              ) : null}
            </div>
          </div>
          <button
            type="submit"
            disabled={formik.isSubmitting}
            className={` w-full text-white rounded-lg h-10 mt-8 text-sm mb-8 flex justify-center items-center`}
            style={{
              backgroundColor: isValidNationalId
                ? theme.palette.primary.main
                : theme.palette.grey[100],

              color: isValidNationalId
                ? theme.palette.common.white
                : theme.palette.text.disabled,
            }}
          >
            {loading ? (
              <CircularProgress
                sx={{
                  color: theme.palette.common.white,
                }}
                size={30}
              />
            ) : (
              "ارسال کد تایید"
            )}
          </button>
        </form>
      </div>
    </>
  );
};

export default LoginPanel;
